import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import SignalRServiceModel from './SignalRServiceModel';
import { json } from 'stream/consumers';

interface Props {
  onIncomingCallDetails?: Function;
  onEndCallDetails: Function;
}

const SignalCallerServiceModel = (props: Props) => {

  const signalRService: SignalRServiceModel = new SignalRServiceModel("wss://speakcom.superbit.co.il")
  const callerConnection = signalRService.getSpeakComConnection();

  // callerConnection.off("EndOfCallDetails");
  callerConnection.on("EndOfCallDetails", (message) => {

    const jsonObject = JSON.parse(message.replace("NEW:", ""));
    let treatmentId = jsonObject.treatment.Id;
    const loggerUser = localStorage.getItem('loggedUser');
    if (loggerUser) {
      const parsedUser = JSON.parse(loggerUser);
      if (parsedUser && parsedUser.id) {
        if(parsedUser.extensions != jsonObject.treatment.From && parsedUser.extensions != jsonObject.treatment.To) {
          return; // Ignore if the user is not the one who initiated the call
        }
      }
    } else {
      return; // Ignore if no user is logged in
    }
    
    // 
    const treatmntIds = localStorage.getItem('treatmentIds');
    if (treatmntIds) {
      const parsedTreatmentIds = JSON.parse(treatmntIds);
      if (parsedTreatmentIds.includes(treatmentId)) {
        return; // Ignore if the treatment ID already exists in local storage
      }
      parsedTreatmentIds.push(treatmentId);
      localStorage.setItem('treatmentIds', JSON.stringify(parsedTreatmentIds));
    } else {
      localStorage.setItem('treatmentIds', JSON.stringify([treatmentId]));
    }
    
    console.log('SignalCallerServiceModel-EndOfCallDetails', jsonObject)

    console.log('SignalR EndOfCallDetails', jsonObject);

    let _message = '';
    switch (jsonObject.Type) {
      case 1:
        _message = "נוספה שיחה חדשה לטיפול שוטף"
        break;
      case 2:
        _message = "יש להוסיף את השיחה לטיפול שוטף"
        break;
      case 3:
        _message = "מספר הטלפון  לא זוהה במערכת"
        break;
    }
    props.onEndCallDetails(jsonObject, _message);
  });

  // callerConnection.off("IncomingCallDetails");
  callerConnection.on("IncomingCallDetails", (message) => {
    const jsonObject = JSON.parse(message);
    
    const loggerUser = localStorage.getItem('loggedUser');
    if (loggerUser) {
      const parsedUser = JSON.parse(loggerUser);
      if (parsedUser && parsedUser.id) {
        if(parsedUser.extensions != jsonObject.extension) {
          return; // Ignore if the user is not the one who initiated the call
        }
      }
    } else {
      return; // Ignore if no user is logged in
    }
    // 
    
    let lead = jsonObject.lead;
    let customer = jsonObject.customer;
    let phone = jsonObject.phone;
    let callId = jsonObject.callId;
    
    const callIds = localStorage.getItem('callIds');
    if (callIds) {
      const parsedCallIds = JSON.parse(callIds);
      if (parsedCallIds.includes(callId)) {
        return; // Ignore if the call ID already exists in local storage
      }
      parsedCallIds.push(callId);
      localStorage.setItem('callIds', JSON.stringify(parsedCallIds));
    } else {
      localStorage.setItem('callIds', JSON.stringify([callId]));
    }
    console.log('IncomingCallDetails-jsonObject', jsonObject)

    // console.log('SignalR IncomingCallDetails', jsonObject);
    props.onIncomingCallDetails && props.onIncomingCallDetails(lead, customer, phone);
  });


  return null; // Replace with valid JSX if needed

}


export default SignalCallerServiceModel
